// extracted by mini-css-extract-plugin
export default {"description":"AlertDialog_description__F2Ac0","buttonText":"AlertDialog_buttonText__yfzmO"};